(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('seeking-settings', {
            parent: 'entity',
            url: '/seeking-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.seekingSettings.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/seeking-settings/seeking-settings.html',
                    controller: 'SeekingSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('seekingSettings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('seeking-settings-detail', {
            parent: 'entity',
            url: '/seeking-settings/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'publicGatewayApp.seekingSettings.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/seeking-settings/seeking-settings-detail.html',
                    controller: 'SeekingSettingsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('seekingSettings');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SeekingSettings', function($stateParams, SeekingSettings) {
                    return SeekingSettings.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'seeking-settings',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('seeking-settings-detail.edit', {
            parent: 'seeking-settings-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-settings/seeking-settings-dialog.html',
                    controller: 'SeekingSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SeekingSettings', function(SeekingSettings) {
                            return SeekingSettings.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('seeking-settings.new', {
            parent: 'seeking-settings',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-settings/seeking-settings-dialog.html',
                    controller: 'SeekingSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ageFrom: null,
                                ageTo: null,
                                onlyFromMyMatches: null,
                                genderSet: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('seeking-settings', null, { reload: 'seeking-settings' });
                }, function() {
                    $state.go('seeking-settings');
                });
            }]
        })
        .state('seeking-settings.edit', {
            parent: 'seeking-settings',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-settings/seeking-settings-dialog.html',
                    controller: 'SeekingSettingsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SeekingSettings', function(SeekingSettings) {
                            return SeekingSettings.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('seeking-settings', null, { reload: 'seeking-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('seeking-settings.delete', {
            parent: 'seeking-settings',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/seeking-settings/seeking-settings-delete-dialog.html',
                    controller: 'SeekingSettingsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SeekingSettings', function(SeekingSettings) {
                            return SeekingSettings.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('seeking-settings', null, { reload: 'seeking-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
